import React from "react";
import Tilt from "react-tilt";
import { motion } from "framer-motion";
import { styles } from "../styles";
import { services } from "../constants";
import { fadeIn, textVariant } from "../utils/motion";
import { SectionWrapper } from "../hoc";

const ServiceCard = ({ index, title, icon }) => {
  return (
    <Tilt className="xs:w-[250px] w-full">
      <motion.div
        variants={fadeIn("right", "spring", 0.5 * index, 0.75)}
        className="w-full green-pink-gradient p-[1px] rounded-[20px] shadow-card"
      >
        <div
          options={{
            max: 45,
            scale: 1,
            speed: 450,
          }}
          className="bg-tertiary rounded-[20px] py-5 px-12 min-h-[280px] flex justify-evenly items-center flex-col"
        >
          <img src={icon} alt={title} className="w-16 h-16 object-contain" />

          <h3 className="text-white text-[20px] font-bold text-center">
            {title}
          </h3>
        </div>
      </motion.div>
    </Tilt>
  );
};

const About = () => {
  return (
    <>
      <motion.div variants={textVariant()}>
        <p className={styles.sectionSubText}> Introduction</p>
        <h2 className={styles.sectionHeadText}>Overview</h2>
      </motion.div>

      <motion.p
        variants={fadeIn("", "", 0.1, 1)}
        className="flex flex-col space-y-1 mt-4  text-secondary text-[17px] max-w-3xl leading-[30px] "
      >
        <p>
          I am a passionate Machine Learning DevOps Engineer and Full Stack
          Developer with 4+ years of experience building and deploying
          innovative, data-driven solutions that enhance organizational
          performance and solve real-world challenges. My expertise spans MLOps,
          LLM systems integration, scalable backend development, and AI-powered
          mobile/web platforms.
        </p>

        <p>
          I thrive at the intersection of AI, DevOps, and software engineering,
          with a focus on deploying and optimizing machine learning models in
          production environments. I’m currently expanding my expertise in local
          Large Language Model (LLM) orchestration — running and connecting
          models like Llama and Mistral locally to Onyx systems for secure,
          health-focused AI applications.
        </p>

        <p>
          I’m a fast learner, criticalthinker, and strong collaborator dedicated
          to leveraging technology for meaningful impact, particularly in
          healthcare innovation and equitable access to AI in Africa.
        </p>
      </motion.p>

      <div className="mt-20 flex flex-wrap gap-10 ">
        {services.map((service, index) => (
          <ServiceCard key={service.title} index={index} {...service} />
        ))}
      </div>
    </>
  );
};

export default SectionWrapper(About, "about");
